// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"DuplicateLanding_cancelButton__3GSQk","divider":"DuplicateLanding_divider__22bXH"};